export default __webpack_public_path__ + "static/media/sign-in.3b1b0bc9.jpg";